import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const safetyrepsAdapter = getAdapter();
const safetyrepsSlice = createSlice({
  name: 'safetyreps',
  initialState: safetyrepsAdapter.getInitialState(),
  reducers: {
    setSafetyReps: (state, { payload: { safetyreps } }) => {
      safetyrepsAdapter.setAll(state, safetyreps);
    }
  }
});

const selectors = safetyrepsAdapter.getSelectors(({ safetyreps }) => safetyreps);

export const getSafetyRepsIncludingDeleted = state => selectors.selectAll(state);

export const getSafetyReps = state => getSafetyRepsIncludingDeleted(state).filter(({ active }) => active);

export const { setSafetyReps } = safetyrepsSlice.actions;

export default safetyrepsSlice.reducer;
